export default "__VITE_ASSET__CDyVBczv__"